import {observer} from "mobx-react"
import React, {Component} from "react"
import {Button, Icon, Input, Segment} from "semantic-ui-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore"
import _ from "lodash"
import {Link} from "react-router-dom"
import Price from "components/Price/Price"
import ButtonLove from "components/Button/ButtonLove"
import { Label } from "semantic-ui-react"
import OrderModel   from "shop/OrderModel";
import ImageWithFallback from "components/ImageWithFallback"
import Responsive from "react-responsive"

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0

@observer
export default class ProductListItem extends Component {

	state = {
		session: shop.session || {}, 
		locations: [], 
		showAddressBook: false, 
		noMoreOrders: false, 
		orderOpen: [], 
		maxOrders: 5, 
		maxOpenOrders: 5,
		count: 1
	  }

	  loadSession = ( session ) => {
		this.setState( { noMoreOrders: false } )
	  }
	  componentDidMount() {
		orders = []
		ordersWithOpenPositions = []
		openPositions = []
		current = 0
		shop.events.authentified.add( this.loadSession )
		// this.loadSession()
	  }
	
	render() {
		let {product, index, categoryId = "", to = "/", search = "", flashing} = this.props
		//console.log("this.props",this.props)
		if ( !product ) return <div>NO PRODUCT</div>
		let configByCategory = cmsStore.config.orthoFieldConfigByCategory[String( product.category && product.category.map_id )]

		let isDefaultConfig = false
		if ( !configByCategory ) {
			isDefaultConfig = true
			configByCategory = cmsStore.config.orthoFieldConfigByCategory["DEFAULT"]
		}
		const columnChunks = _.chunk( configByCategory.columns, 1 )
		const inCart = shop.cart.productsById.get( product.map_id ) || product

		// Add the flashing effect
		return ( 
			<div className={` ${flashing ? 'flash-animation' : ''}`}>
				<Responsive minWidth={790}>
				<table>
					<colgroup>
						<col className="w-40" />
						<col className="w-20" />
						<col className="w-20" />
					</colgroup>
					<tbody>
						<tr className="bb pl2 pr2" style={{ backgroundColor: product.count >= 1 ? "rgb(240, 240, 240)" : "transparent", borderBottom: "1px solid #917236"}}>
							<td className="tl" style={{ "paddingLeft": "10px", "paddingRight": "0px"}}>
								{product.article_nr}  <a className="black-90 fw7">{product.desc.short_des}</a>
							</td>
							{shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" && 
							<td className="tc">
								<div className="ProductListItem-title">
									{product.extras && product.extras.edeka_nan && product.extras.edeka_nan.value.value && <div>{product.extras.edeka_nan.value.value}</div>}
								</div>
							</td>}
							<td className="tc">
								<div className="ProductListItem-title">
									{product.barcode}
								</div>
							</td>
							<td className="tr"><div>
								{product &&
								<Input style={{border: "none"}} className="transparent bw1 pr1 pl1" type="number" min={0} placeholder={product.count || 1} 
									
									value={product.count}
									action 
									onChange={e => {
									this.setState({ count: e.target.value });
									product.count = e.target.value
									}}
									onBlur={e => {
										shop.cart.add( product )
									}}>
									<Button  icon="minus" onClick={() => {
									product.count = product.count - 1
									if(product.count < 1){
										product.count = 0
				
									}
									console.log("product.count",product.count)
									shop.cart.add( product )
									}} />
									<input style={{ width: "80px", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} />
									<Button className="mr2" icon="plus" onClick={() => {
									product.count = product.count + 1
									this.setState({ count: product.count });
									console.log("product.count",product.count)
									shop.cart.add( product )
									}} />

								</Input>} 
										
									</div>
							</td>
						</tr>
					</tbody>
				</table>
				</Responsive>
				<Responsive maxWidth={789}>
				<table>
					<colgroup>
						<col className="w-30" />
						<col className="w-70" />
					</colgroup>
					<tbody>
						<tr>
							<td className="tl fw7" style={{ backgroundColor: product.count >= 1 ? "rgb(240, 240, 240)" : "transparent"}}>
								Artikel:
							</td>
							<td className="tr bb b--black-20" style={{ backgroundColor: product.count >= 1 ? "rgb(240, 240, 240)" : "transparent"}}>
								{product.article_nr} - <a className="black-90 fw7">{product.desc.short_des}</a>
							</td>
						</tr>
						{<tr>
							<td className="tl fw7" style={{ backgroundColor: product.count >= 1 ? "rgb(240, 240, 240)" : "transparent"}}>
								EAN:
							</td>
							<td className="tr bb b--black-20" style={{ backgroundColor: product.count >= 1 ? "rgb(240, 240, 240)" : "transparent"}}>
								{product.barcode}
							</td>
						</tr>}
						{shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" &&<tr>
							<td className="tl fw7" style={{ backgroundColor: product.count >= 1 ? "rgb(240, 240, 240)" : "transparent"}}>
								EDEKA Art-Nr.:
							</td>
							<td className="tr bb b--black-20" style={{ backgroundColor: product.count >= 1 ? "rgb(240, 240, 240)" : "transparent"}}>
								{product.extras && product.extras.edeka_nan && product.extras.edeka_nan.value.value && <div>{product.extras.edeka_nan.value.value}</div>}
							</td>
						</tr>}
						<tr >
							<td className="fw7" style={{ backgroundColor: product.count >= 1 ? "rgb(240, 240, 240)" : "transparent", borderBottom: "3px solid #917236"}}>Restanten:</td>
							<td className="tr bb b--black-20" style={{ backgroundColor: product.count >= 1 ? "rgb(240, 240, 240)" : "transparent", borderBottom: "3px solid #917236"}}>
								<div className="ProductListItem-title">
									{product &&
								<Input style={{border: "none"}} className="transparent bw1 pr1 pl1" type="number" min={0} placeholder={product.count || 1} 
								defaultValue={0} 
								value={product.count}
								action 
								onChange={e => {
								this.setState({ count: e.target.value });
								product.count = e.target.value
								}}
								onBlur={e => {
									shop.cart.add( product )
								}}>
								<Button  icon="minus" onClick={() => {
								product.count = product.count - 1
								if(product.count < 1){
									product.count = 0
			
								}
								console.log("product.count",product.count)
								shop.cart.add( product )
								}} />
								<input style={{ width: "80px", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} />
								<Button className="mr2" icon="plus" onClick={() => {
								product.count = product.count + 1
								this.setState({ count: product.count });
								console.log("product.count",product.count)
								shop.cart.add( product )
								}} />

							</Input>} 
										
									</div>
							</td>
						</tr>
					</tbody>
				</table>
				</Responsive>
			</div>
		)


	}
}

function ProductQuantitySimple( {product, inCart = {}} ) {
	const [count, setCount] = React.useState( inCart && inCart.count || 0 )
	const [isDirty, setDirty] = React.useState( false )
	const [isLoading, setLoading] = React.useState( false )
	const same = count === inCart.count
	React.useEffect( () => {
		if ( isDirty ) return // so the input doesnt overwrite user inputted data
		setCount( inCart.count )
	}, [product, inCart] )
	return <div className={"ProductQuantitySimple flex flex-row items-center"}>
		<div className={"pr2"} style={{width: "80px"}}><Input onChange={e => {
			setCount( e.currentTarget.value )
			setDirty( true )
		}} value={count} fluid type={"number"} min={0} /></div>
		<Button
			color={same ? null : "green"}
			loading={isLoading}
			icon={same ? "shopping cart" : "plus"}
			onClick={async () => {
				let n = count

				if ( !n ) {
					n = 1
				} else {
					if ( same ) return
				}

				setLoading( true )
				product.count = n
				shop.cart.add( product )
				setDirty( false )
				await delay( 300 )
				setLoading( false )
			}} />
	</div>
}

function delay( ms ) {
	return new Promise( resolve => setTimeout( resolve, ms ) );
}


// WEBPACK FOOTER //
// ./src/theme/lindt/components/Product/ProductListItem.js